//@ts-ignore
import data from '../.freec/static/locations.json'
export default data
